export default class Formatter {
  public static formatDate(date: Date) {
    return new Intl.DateTimeFormat("en-US", {
      dateStyle: "short",
      timeStyle: "short",
    }).format(date);
  }
}
